module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/testimonial-picture3-f859967f12ab4e0a78b1cabee90f0463.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/testimonial-picture3.png
// module id = 1611
// module chunks = 0